module.exports = function initServiceGrid() {
  const blocks = document.querySelectorAll('.service-grid')

  blocks.forEach((block) => {
    const categorySelect = block.querySelector('[data-service-grid-category]')
    const searchInput = block.querySelector('[data-service-grid-search]')
    const cards = Array.from(block.querySelectorAll('[data-service-card]'))
    const emptyState = block.querySelector('[data-service-grid-empty]')

    if (!cards.length) {
      return
    }

    const applyFilters = () => {
      const categoryValue = categorySelect ? categorySelect.value.trim().toLowerCase() : ''
      const searchValue = searchInput ? searchInput.value.trim().toLowerCase() : ''
      let visibleCount = 0

      cards.forEach((card) => {
        const categories = (card.dataset.categories || '').toLowerCase().split('|').filter(Boolean)
        const searchable = (card.dataset.search || '').toLowerCase()
        const matchesCategory = !categoryValue || categories.includes(categoryValue)
        const matchesSearch = !searchValue || searchable.includes(searchValue)
        const isVisible = matchesCategory && matchesSearch

        card.hidden = !isVisible

        if (isVisible) {
          visibleCount += 1
        }
      })

      if (emptyState) {
        emptyState.hidden = visibleCount > 0
      }
    }

    if (categorySelect) {
      categorySelect.addEventListener('change', applyFilters)
    }

    if (searchInput) {
      searchInput.addEventListener('input', applyFilters)
    }

    applyFilters()
  })
}
